import Cookies from 'cookies-js';

const RETURNING_USER_PREFIX = 'returningUser_';
export const setReturningUserCookie = (eventId: string) => {
    const cookieName = `${RETURNING_USER_PREFIX}${eventId}`;
    const visitCount = parseInt(Cookies.get(cookieName)) || 0;
    Cookies.set(cookieName, visitCount + 1, { expires: Infinity });
};

export const getReturningUserCookie = (eventId: string) => {
    const cookieName = `${RETURNING_USER_PREFIX}${eventId}`;
    return parseInt(Cookies.get(cookieName)) || 0;
};
